import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_PRODUCT_DETAILS,
} from './appsheetTypes'

export default (state, action) => {
    switch (action.type) {
        case GET_PRODUCT_DETAILS:
            return {
                ...state,
                all_products: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: {},
            }
        default:
            return state
    }
}
